// extracted by mini-css-extract-plugin
var _1 = "RentalPortalListingsBoardCard-moduleRentalPortalListingsBoardCard__Bi_mp";
var _2 = "RentalPortalListingsBoardCard-moduleactive__PZG0G";
var _3 = "RentalPortalListingsBoardCard-modulebadge__neL4z";
var _4 = "RentalPortalListingsBoardCard-modulebody__Dlrh0";
var _5 = "RentalPortalListingsBoardCard-modulemarker__cq42m";
var _6 = "RentalPortalListingsBoardCard-modulemeta__Pr0kb";
var _7 = "RentalPortalListingsBoardCard-moduleneedsYou__a8cs9";
var _8 = "RentalPortalListingsBoardCard-moduletitle__gMlPn";
export { _1 as "RentalPortalListingsBoardCard", _2 as "active", _3 as "badge", _4 as "body", _5 as "marker", _6 as "meta", _7 as "needsYou", _8 as "title" }
